/**
 * Side-effect module: registers every built-in duel. Import once from the app entry. Boards
 * are lazy, so no other page downloads a duel.
 */
import { chessModule } from "./chess/module";
import { connectFourModule } from "./connect-four/module";
import { fallingBlocksVersusModule } from "./falling-blocks-versus/module";
import { registerDuel } from "./registry";

// The admin's games list offers them in this order, after the games.
registerDuel(chessModule);
registerDuel(connectFourModule);
registerDuel(fallingBlocksVersusModule);
